import { getRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const getMMIDList = async () => {
  try {
    return await getRequest(urls.GET_MMID_LIST);
  } catch (err) {
    return err;
  }
};

export const getMMIDDescriptionList = async () => {
  try {
    return await getRequest(urls.GET_MMID_DESCRIPTION_LIST);
  } catch (err) {
    return err;
  }
};

export const getContractDetails = async (mmid, salesOrg) => {
  try {
    return await getRequest(urls.GET_CONTRACT_DETAILS + `/${mmid}` + `/${salesOrg}`);
  } catch (err) {
    return err;
  }
};
